import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useAdminRole } from '@/hooks/useAdminRole';
import AdminSidebar from './components/AdminSidebar';
import AccountManager from './components/AccountManager';
import DiscountManager from './components/DiscountManager';
import TelegramManager from './components/TelegramManager';
import LandingStSettings from './components/LandingStSettings';
import TourProductManager from './components/TourProductManager';

export default function AdminPage() {
  const { loading, isSuperAdmin } = useAdminRole();
  const [activeTab, setActiveTab] = useState('accounts');

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 pt-24 md:pt-28 pb-16 md:pb-20">
        {loading ? (
          <div className="flex items-center justify-center py-40">
            <div className="flex flex-col items-center gap-3 text-secondary-500">
              <i className="ri-loader-4-line animate-spin text-3xl text-primary-500" />
              <span className="text-sm">Checking access...</span>
            </div>
          </div>
        ) : !isSuperAdmin ? (
          <div className="max-w-md mx-auto text-center py-20">
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 flex items-center justify-center">
              <i className="ri-lock-line text-2xl text-red-500" />
            </div>
            <h1 className="mt-6 font-heading text-2xl font-bold text-secondary-900">
              Access denied
            </h1>
            <p className="mt-2 text-sm text-secondary-500 leading-relaxed">
              This area is restricted to administrators. If you believe this is a
              mistake, please contact the Super Admin.
            </p>
            <Link
              to="/"
              className="mt-6 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-md px-6 py-3 transition-colors whitespace-nowrap"
            >
              Back to home
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        ) : (
          <div className="max-w-6xl mx-auto">
            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-secondary-900">
                Admin Panel
              </h1>
              <p className="mt-2 text-sm text-secondary-500">
                Manage administrator accounts, discounts, notifications, landing.st sync and tour products from one place.
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6">
              <AdminSidebar
                activeTab={activeTab}
                onTabChange={setActiveTab}
              />

              <div className="flex-1 min-w-0">
                {activeTab === 'accounts' && <AccountManager />}
                {activeTab === 'discounts' && <DiscountManager />}
                {activeTab === 'telegram' && <TelegramManager />}
                {activeTab === 'landing_st' && <LandingStSettings />}
                {activeTab === 'tour_products' && <TourProductManager />}
              </div>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}